<template>
  <section
    class="flex items-center justify-between p-3 text-sm font-semibold text-gray-400 xl:pt-0"
  >
    <div
      class="relative w-2/5"
      @mouseenter="displayTreeInfo = true"
      @mouseleave="displayTreeInfo = false"
    >
      <p
        v-show="displayTreeInfo"
        class="absolute -top-16 right-0 z-50 whitespace-nowrap rounded border border-emerald-700 bg-white p-2 font-light text-emerald-700"
      >
        1 tCO2e is equivalent to carbon sequestered by 16.5 tree seedlings
        grown for 10 years
      </p>
      <a
        href="https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references#seedlings"
        target="_blank"
      >
        <NuxtImg
          src="/Trees.png"
          alt="Carbon Equivalence Calculator - Number of trees"
          class="h-auto w-48"
        />
      </a>
    </div>
    <div class="flex items-end gap-2">
      <h4 class="text-3xl font-semibold text-slate-900">
        {{ numberOfTrees }}
      </h4>
      <span class="text-xs font-light">trees</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CarbonEquivalenceCalculator',

  props: {
    emissions: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      totalEmissions: this.emissions,
      displayTreeInfo: false,
    }
  },

  computed: {
    numberOfTrees() {
      return thousands(Math.ceil(this.totalEmissions * 16.5))
    },
  },

  watch: {
    emissions(newTotal) {
      this.totalEmissions = newTotal
    },
  },
}
</script>
